import { render, staticRenderFns } from "./CombineLegForm.vue?vue&type=template&id=379bcde2&scoped=true"
import script from "./CombineLegForm.vue?vue&type=script&lang=js"
export * from "./CombineLegForm.vue?vue&type=script&lang=js"
import style0 from "./CombineLegForm.vue?vue&type=style&index=0&id=379bcde2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379bcde2",
  null
  
)

export default component.exports